import { motion, useScroll, useTransform } from "framer-motion";

function ParallaxBackground() {
    const { scrollY } = useScroll();

    // Фон смещается на 30% от скорости скролла
    const y = useTransform(scrollY, (value) => - value * 0.05);

    return (
        <motion.div
            className="parallax-bg"
            style={{ y }}
        />
    );
}

export default ParallaxBackground;